export function SliderLinesBg(props: React.SVGProps<SVGSVGElement> & { hideBox?: boolean }) {
  const { hideBox, ...svgProps } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1441"
      height="1209"
      fill="none"
      viewBox="0 0 1441 1209"
      preserveAspectRatio="none"
      {...svgProps}
    >
      <path
        stroke="#E5E5E5"
        d="M.5 2.039V1208.5M480.5 2.039V1208.5M1199.49 0v1206.47M241.5 1.529V1207.99M960.5 2.039V1208.5M720.5 2.039V1208.5M1440.48 2.039V1208.5"
      ></path>
      {!hideBox && <path fill="#fff" stroke="#E5E5E5" d="M403.5 132.5h633v541h-633z"></path>}
    </svg>
  );
}

export function SliderLinesBgMobile(props: React.SVGProps<SVGSVGElement> & { hideBox?: boolean }) {
  const { hideBox, ...svgProps } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="462"
      height="810"
      fill="none"
      viewBox="0 0 462 810"
      preserveAspectRatio="none"
      {...svgProps}
    >
      <g stroke="#E5E5E5" opacity="0.4">
        <path d="M.5 1.367v808.124M154.169 1.367v808.124M384.35 0v808.124M77.655 1.023v808.124M307.838 1.367v808.124M231.003 1.367v808.124M461.5 1.367v808.124"></path>
      </g>
      {!hideBox && <path fill="#fff" stroke="#E5E5E5" d="M52.5 36.5h357v541h-357z"></path>}
    </svg>
  );
}
